import axios from "axios";

const survey = (data) => {
  return new Promise((resolve, reject) => {
    axios.post(process.env.REACT_APP_BASE_URL + "/survey", data)
      .then(response => resolve(response.data))
      .catch(error => reject(error));
  });
};

export default survey;